import React from 'react';
import { Button, Modal, Form, Input, Select, DatePicker, message } from 'antd';
import { api, onPost, onGet } from '../../../../core/api';

const Option = Select.Option;
const { RangePicker } = DatePicker;

class OKExContractQuantEditView extends React.Component {

    constructor() {
        super();
        this.state = {
            contracts: [],
            model: 0,
            type: 0
        }
        this.onClick = this.onClick.bind(this);
        this.onChange = this.onChange.bind(this);
    }

    componentDidMount() {
        onGet(api.getOKExContractInfo.url).then(response => {
            if (response === undefined) {
                return;
            }
            this.setState({ contracts: response });
        });
    }

    onClick(type) {
        switch (type) {
            case 'confirm':
                this.props.form.validateFieldsAndScroll((error, fields) => {
                    if (error) {
                        return;
                    }
                    const backTestBeginTime = fields.backTestTime ? fields.backTestTime[0].format('YYYY-MM-DD HH:mm:ss') : null;
                    const backTestEndTime = fields.backTestTime ? fields.backTestTime[1].format('YYYY-MM-DD HH:mm:ss') : null;
                    let parameters;
                    if (parseInt(fields.model) === 1) {
                        parameters = {
                            margin_volume: parseInt(fields.marginVolume)
                        };
                    } else if (parseInt(fields.model) === 2) {
                        parameters = {
                            open_volume: parseInt(fields.openVolume)
                        };
                    }
                    onPost(api.addOKExContractQuant.url, api.addOKExContractQuant.params(fields.instrument, fields.model, fields.type,
                        JSON.stringify(parameters), backTestBeginTime, backTestEndTime)).then(response => {
                            if (response === undefined) {
                                return;
                            }
                            message.success('添加成功');
                            this.props.onModalFinish();
                        });
                });
                break;
            default:
                break;
        }
    }

    onChange(type, value) {
        switch (type) {
            case 'model':
                this.setState({ model: parseInt(value) })
                break;
            case 'type':
                this.setState({ type: parseInt(value) })
                break;
            default:
                break;
        }
    }

    render() {
        let contracts = [];
        this.state.contracts.forEach(contract => {
            contracts.push(<Option key={contract.instrument_id}>{contract.symbol + '永续合约'}</Option>);
        });
        const formItemLayout = {
            labelCol: { span: 4 },
            wrapperCol: { span: 20 }
        };
        return (
            <Modal title={'添加'} visible={true} okButtonProps={{ hidden: true }} cancelButtonProps={{ hidden: true }} onCancel={this.props.onModalCancel}>
                <Form>
                    <Form.Item {...formItemLayout} label="合约种类">
                        {this.props.form.getFieldDecorator('instrument', {
                            rules: [{ required: true, message: '请选择合约种类' }]
                        })(
                            <Select placeholder="请选择合约种类">
                                {contracts}
                            </Select>
                        )}
                    </Form.Item>
                    <Form.Item {...formItemLayout} label="量化模型">
                        {this.props.form.getFieldDecorator('model', {
                            rules: [{ required: true, message: '请选择量化模型' }]
                        })(
                            <Select placeholder="请选择量化模型" onChange={value => this.onChange('model', value)}>
                                <Option key="1">补仓量化</Option>
                                <Option key="2">趋势量化</Option>
                            </Select>
                        )}
                    </Form.Item>
                    <Form.Item {...formItemLayout} label="量化类型">
                        {this.props.form.getFieldDecorator('type', {
                            rules: [{ required: true, message: '请选择量化类型' }]
                        })(
                            <Select placeholder="请选择量化类型" onChange={value => this.onChange('type', value)}>
                                <Option key="1">回测</Option>
                                <Option key="2">实盘</Option>
                            </Select>
                        )}
                    </Form.Item>
                    {/* 补仓量化的参数 */}
                    <div hidden={this.state.model !== 1}>
                        <Form.Item {...formItemLayout} label="补仓量">
                            {this.props.form.getFieldDecorator('marginVolume', {
                                rules: [{ required: this.state.model === 1, message: '请输入补仓量' }, { pattern: /^[0-9]*$/, message: '请输入纯数字' }]
                            })(
                                <Input placeholder="请输入补仓量" maxLength="5" addonAfter="张" />
                            )}
                        </Form.Item>
                    </div>
                    {/* 趋势量化的参数 */}
                    <div hidden={this.state.model !== 2}>
                        <Form.Item {...formItemLayout} label="开仓量">
                            {this.props.form.getFieldDecorator('openVolume', {
                                rules: [{ required: this.state.model === 2, message: '请输入开仓量' }, { pattern: /^[0-9]*$/, message: '请输入纯数字' }]
                            })(
                                <Input placeholder="请输入开仓量" maxLength="5" addonAfter="张" />
                            )}
                        </Form.Item>
                    </div>
                    {/* 回测的参数 */}
                    <div hidden={this.state.type !== 1}>
                        <Form.Item {...formItemLayout} label="回测时间">
                            {this.props.form.getFieldDecorator('backTestTime', {
                                rules: [{ required: this.state.type === 1, message: '请选择回测时间' }]
                            })(
                                <RangePicker format={'YYYY-MM-DD HH:mm:ss'} showTime={true} placeholder={['请选择回测开始时间', '请选择回测结束时间']} />
                            )}
                        </Form.Item>
                    </div>
                    <Form.Item wrapperCol={{ span: 20, offset: 4 }}>
                        <Button type="primary" onClick={() => this.onClick('confirm')}>添加</Button>
                    </Form.Item>
                </Form>
            </Modal>
        );
    }


}

const OKExContractQuantEditModal = Form.create()(OKExContractQuantEditView);
export default OKExContractQuantEditModal;


// WEBPACK FOOTER //
// ./src/page/jsx/coin/okex/OKExContractQuantEditModal.jsx